import { useLocation } from "@gatsbyjs/reach-router";
import React, { useMemo, useState } from "react";
import { findLangPath, languages, navigateWithLang } from "../../utils/lang";
import { PhosphorIcon } from "../PhosphorIcon/PhosphorIcon";
import { Icons } from "../PhosphorIcon/types";
import { Link } from "gatsby";

export const MobileLangSelect = () => {
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);

  const currentLang = useMemo(() => {
    return (
      languages.find((lang) => lang.code === findLangPath(location)) ||
      languages[0]
    );
  }, []);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="MobileLangSelect__container">
        <span
          className="MobileLangSelect__Select"
          onClick={handleOpen}
          data-testid="open-button"
        >
          <span>{currentLang.name}</span>
          <PhosphorIcon icon={Icons.CaretDown} size={16} />
        </span>
        {isOpen && (
          <div className="MobileLangSelect__options">
            {languages.map((lang, index) => (
              <Link
                key={index}
                to={navigateWithLang(lang.code, location)}
                className="MobileLangSelect__option"
              >
                {lang.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
